module.exports = __webpack_public_path__ + "img/svg/icon-players.9ea46c55a694ec76c107800aab4f5abb.svg";